import React, { ChangeEvent } from "react";
import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio as MuiRadio,
  RadioGroup,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { tokens } from "../../theme";

interface RadioButtonProps {
  name?: string;
  options?: { value: any; label: string | JSX.Element }[];
  label?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  control: Control<any, any>;
  isDisabled?: boolean
  rules?: object
  controllerName?: string;
  xs?: number;
  md?: number;
  value?: string;
  defaultValue?: string | boolean;
  radioSx?: SxProps<Theme>;
  radioLabelSx?: SxProps<Theme>;
}

const CustomRadioButton: React.FC<RadioButtonProps> = (props) => {

  const { name, options, label, onChange, control, isDisabled, rules, controllerName, xs, md, value, defaultValue, radioSx, radioLabelSx  } = props;
  const theme = useTheme();
 const colors = tokens(theme.palette.mode);
  return (
    <Controller
      name={controllerName || ""}
      control={control}
      rules={rules ? rules : {}}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => (
        <>
          {label && <FormLabel component="legend" sx={{ color: fieldState.error ? theme.palette.error.main : 'inherit' }}>{label}</FormLabel>}
          <RadioGroup defaultValue={defaultValue} name={name ? name : controllerName} onChange={(e) => { field.onChange(e); onChange && onChange(e) }}>
            <Grid container spacing={1}>
              {options?.map((option) => (
                <Grid item md={md} xs={xs}>
                  <FormControlLabel
                    {...field}
                    key={option.value}
                    value={option.value?.toString()}
                    control={
                      <MuiRadio
                        color={theme.palette.mode === "dark" ? "secondary" : "primary"}
                        checked={option.value?.toString() === field.value?.toString() || option.value?.toString() === value}
                        sx={{
                          color: fieldState.error && !field.value
                            ? theme.palette.error.main
                            : '',
                            ...radioSx,
                          '&.Mui-checked': {
                            color: fieldState.error && !field.value
                              ? theme.palette.error.dark
                              : '',
                          },
                          '&.Mui-disabled': {
                            color: theme.palette.mode === "light" ? colors.grey[300] : '', // Darker color for disabled state
                          },
                        }}
                      />

                    }
                    label={option.label}
                    disabled={isDisabled}
                    sx={{
                      color: fieldState.error ? theme.palette.error.main : 'inherit', 
                      ...radioLabelSx,
                      '& .MuiFormControlLabel-label.Mui-disabled': {
                        color: theme.palette.mode === "light" ? colors.grey[100] : colors.grey[300], // Darker label color for disabled state
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </RadioGroup>
          {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
        </>
      )}
    />

  );
};

export default CustomRadioButton;
